'use strict'
export default function () {
	if (jQuery.magnificPopup) {
		jQuery.extend(true, jQuery.magnificPopup.defaults, {
			tClose: 'Zamknij (Esc)', // Alt text on close button
			tLoading: 'Ładowanie...', // Text that is displayed during loading. Can contain %curr% and %total% keys
			gallery: {
				tPrev: 'Poprzednie (Lewa strzałka)', // Alt text on left arrow
				tNext: 'Następne (Prawa strzałka)', // Alt text on right arrow
				tCounter: '%curr% z %total%' // Markup for "1 of 7" counter
			},
			image: {
				tError: '<a href="%url%">Zdjęcie</a> nie mogło zostać wczytane.' // Error message when image could not be loaded
			},
			ajax: {
				tError: '<a href="%url%">Treść</a> nie mógła zostać wczytana.' // Error message when ajax request failed
			}
		})
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/magnificPopupTranslation.js